const AUDIO_TYPES = {
  small: { frequency: 410, slideTo: 620, duration: 0.06, type: "triangle", volume: 0.038 },
  medium: { frequency: 280, slideTo: 450, duration: 0.08, type: "square", volume: 0.045 },
  large: { frequency: 180, slideTo: 290, duration: 0.14, type: "sawtooth", volume: 0.055 },
  grow: { frequency: 220, slideTo: 480, duration: 0.22, type: "triangle", volume: 0.06 },
  dash: { frequency: 520, slideTo: 180, duration: 0.12, type: "sawtooth", volume: 0.04 },
  activate: { frequency: 330, slideTo: 660, duration: 0.18, type: "triangle", volume: 0.05 },
  denied: { frequency: 190, slideTo: 120, duration: 0.16, type: "square", volume: 0.05 },
  winA: { frequency: 392, slideTo: 523, duration: 0.22, type: "triangle", volume: 0.05 },
  winB: { frequency: 523, slideTo: 659, duration: 0.25, type: "triangle", volume: 0.05 },
  lose: { frequency: 180, slideTo: 92, duration: 0.35, type: "sawtooth", volume: 0.06 },
};

export class SynthAudio {
  constructor() {
    this.context = null;
    this.masterGain = null;
  }

  async unlock() {
    if (!this.context) {
      this.context = new window.AudioContext();
      this.masterGain = this.context.createGain();
      this.masterGain.gain.value = 0.58;
      this.masterGain.connect(this.context.destination);
    }

    if (this.context.state === "suspended") {
      await this.context.resume();
    }
  }

  play(kind) {
    if (!this.context || !this.masterGain) {
      return;
    }

    const preset = AUDIO_TYPES[kind];

    if (!preset) {
      return;
    }

    const now = this.context.currentTime;
    const oscillator = this.context.createOscillator();
    const gain = this.context.createGain();

    oscillator.type = preset.type;
    oscillator.frequency.setValueAtTime(preset.frequency, now);
    oscillator.frequency.exponentialRampToValueAtTime(Math.max(30, preset.slideTo), now + preset.duration);

    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.exponentialRampToValueAtTime(preset.volume, now + 0.01);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + preset.duration);

    oscillator.connect(gain);
    gain.connect(this.masterGain);

    oscillator.start(now);
    oscillator.stop(now + preset.duration + 0.02);
  }

  playEat(mass) {
    if (mass >= 4.5) {
      this.play("large");
      return;
    }

    if (mass >= 1.2) {
      this.play("medium");
      return;
    }

    this.play("small");
  }

  playGrowth() {
    this.play("grow");
  }

  playDash() {
    this.play("dash");
  }

  playAbility() {
    this.play("activate");
  }

  playDenied() {
    this.play("denied");
  }

  playWin() {
    this.play("winA");
    setTimeout(() => this.play("winB"), 130);
  }

  playLose() {
    this.play("lose");
  }
}